<template>
  <div class="container logged-out-content">
    <form class="block form-sm" name="forgotPasswordForm" @submit.prevent="requestPasswordReset()">
      <header>
        <div class="pull-left">
          <div class="icon">
            <img src="~assets/images/Patient-Icon.png">
          </div>
        </div>
        <div class="col-xs-9">
          <h2>Forgotten Password</h2>
        </div>
      </header>


      <div class="content text-bold text-center h4">
        Please select the product you would like to reset password for:
      </div>
      <context-selector></context-selector>
      <div v-if="!requestComplete">
        <error-display v-if="errorMessage">{{errorMessage}}</error-display>
        <div class="content">
          <div class="row">
            <input-text v-if="context === 'patient'" name="username" label="Cellphone or email address" v-model="username" :validation="$v.username"></input-text>
            <input-text v-if="context === 'practice'" name="username" label="Username" v-model="username" :validation="$v.username"></input-text>
            <input-text v-if="context === 'academic'" name="username" label="Email address" v-model="username" :validation="$v.username"></input-text>
          </div>
        </div>
        <div class="footer">
          <div class="col-xs-12 pointer text-center">
            <submit-button id="request-password-reset-submit" :loading="loading">Reset Password</submit-button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="content" v-if="requestComplete">
        <p>
          If a user with this
          <span v-if="context === 'patient'">cellphone or email address</span>
          <span v-if="context === 'practice'">Username</span>
          <span v-if="context === 'academic'">email address</span>
          exists, then a message will be sent to their registered cell phone or email address with password reset instructions
        </p>
      </div>
    </form>
    <div v-if="otpAvailable">
    <form class="block form-sm" name="otpSubmitForm" @submit.prevent="sendPasswordResetWithOTP()">
      <error-display v-if="errorMessage">{{errorMessage}}</error-display>
      <div class="content">
        <p>You can also enter the OTP we have sent to your cellphone to reset your password.</p>
        <div class="row">
          <input-text name="otp" label="One Time Pin" v-model="otpValue"></input-text>
        </div>
        <div class="row">
          <input-password name="password" label="Enter New Password" v-model="password" :validation="$v.password"></input-password>
        </div>
        <div class="row">
          <input-password name="confirmPassword" label="Confirm New Password" v-model="confirmPassword" :validation="$v.confirmPassword"></input-password>
        </div>
      </div>
      <div class="footer">
        <div class="col-xs-12 pointer text-center">
          <submit-button id="perform-password-reset-submit" :loading="loading">Change Password</submit-button>
        </div>
        <div class="clear"></div>
      </div>
    </form>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { required, sameAs } from 'vuelidate/lib/validators';
  import { password } from 'utils/validators';
  import InputText from 'components/common/inputs/InputText';
  import SubmitButton from 'components/common/buttons/SubmitButton';
  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';
  import InputPassword from 'components/common/inputs/InputPassword';
  import ContextSelector from 'components/common/ContextSelector';

  export default {
    name: 'forgot-password',
    components: {
      InputText,
      SubmitButton,
      ErrorDisplay,
      InputPassword,
      ContextSelector,
    },
    data: () => ({
      loading: false,
      errorMessage: '',
      username: '',
      requestComplete: false,
      otpAvailable: false,
      otpValue: '',
      password: '',
      confirmPassword: '',
    }),
    validations: {
      username: { required },
      password: {
        required,
        password,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs(model => model.password),
      },
    },
    computed: mapState([
      'context',
    ]),
    methods: {
      clearSendStatus() {
        this.errorMessage = '';
        this.otpAvailable = false;
        this.requestComplete = false;
      },
      clearOTPFields() {
        this.otpValue = '';
        this.password = '';
        this.confirmPassword = '';
      },
      async requestPasswordReset() {
        this.clearSendStatus();
        try {
          this.loading = true;
          const dataVal = await this.$api.requestPasswordReset({
            username: this.username,
          });
          this.otpAvailable = dataVal.otpAvailable;
          this.requestComplete = true;
        } catch (error) {
          this.errorMessage = this.$api.processError(error);
          this.clearOTPFields();
        } finally {
          this.loading = false;
          this.clearOTPFields();
        }
      },
      async sendPasswordResetWithOTP() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          this.errorMessage = this.$api.validationError;
        } else {
          this.clearSendStatus();
          try {
            this.loading = true;
            await this.$api.performPasswordResetWithOtp({
              otp: this.otpValue,
              username: this.username,
              password: this.password,
            });
          } catch (error) {
            this.errorMessage = this.$api.processError(error);
            this.clearOTPFields();
          } finally {
            this.loading = false;
            this.clearOTPFields();
          }
        }
      },
    },
    mounted() {
      // If no context is found, set context to patient
      if (this.$store.state.context === '') {
        this.$store.dispatch('updateContext', {
          context: 'patient',
        });
      }
      this.$on('changeContext', function () {
        this.clearSendStatus();
      });
    },
  };

</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?c149d794